<div class="card">
  <p-toast />
    <div class="card" style="display: flex; justify-content:space-between; padding:0%; align-items:center; border: none; background-color: transparent;">
        <div><h4><strong style=" margin-left:10px">Pending Change Request</strong></h4></div>
        <div class="grid">
        <p-button *ngIf="isListView" label="Card View" (click)="cardView()" class="mr-2"/>
        <p-button *ngIf="isCardView" label="List View" (click)="listView()" class="mr-2"/>
        <!-- <button pButton type="button"  style="height:10px; margin-right: 10px; margin-top: -10px; background-color:#2c436b" ></button>    -->
        <p-button label="Report" icon="pi pi-download" (click)="downloadExcel()"/>
        </div>
    </div>
<hr>
    <div *ngIf="isCardView" class="grid">
        <div *ngFor="let vendor of vendorList">
            <div class="col">
                <app-vendor-detail-card  [vendor]="vendor"></app-vendor-detail-card>
            </div>
        </div>
    </div>

    <p-toast />
        <p-table *ngIf="isListView" [value]="vendorList" styleClass="p-datatable-striped p-datatable-gridlines" [paginator]="true" [rows]="5"
        [showCurrentPageReport]="true" [tableStyle]="{ 'min-width': '100rem' }"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"  [rowsPerPageOptions]="[5, 10, 20]">
        <ng-template pTemplate="header">
            <tr>
                <th class="bg-orange"></th>
                <th pSortableColumn="business_name" class="bg-orange">Name <p-sortIcon field="business_name"></p-sortIcon></th>
                <th pSortableColumn="vendor_code" class="bg-orange">Vendor Code <p-sortIcon field="vendor_code"></p-sortIcon></th>
                <th pSortableColumn="primary_address" class="bg-orange">Primary Address <p-sortIcon field="primary_address"></p-sortIcon></th>
                <!-- <th pSortableColumn="vendor_group">Vendor Group <p-sortIcon field="vendor_group"></p-sortIcon></th> -->
                <th pSortableColumn="city" class="bg-orange">City <p-sortIcon field="city"></p-sortIcon></th>
                <th pSortableColumn="state" class="bg-orange">State <p-sortIcon field="state"></p-sortIcon></th>
                <th pSortableColumn="country" class="bg-orange">Country <p-sortIcon field="country"></p-sortIcon></th>
                <th pSortableColumn="gstin" class="bg-orange">GSTIN Number <p-sortIcon field="gstin"></p-sortIcon></th>
                <th pSortableColumn="inventoryStatus" class="bg-orange">Status<p-sortIcon field="status"></p-sortIcon></th>
            </tr>
            <tr>
                <th class="bg-orange"></th>
                <th class="bg-orange">
                    <p-columnFilter
                        type="text"
                        field="business_name"
                        placeholder="Search"
                        ariaLabel="Filter Name" />
                </th>
                <th class="bg-orange">
                    <p-columnFilter
                        type="text"
                        field="vendor_code"
                        placeholder="Search"
                        ariaLabel="Filter Vendor Code" />
                </th>
                <th class="bg-orange">
                    <p-columnFilter
                        type="text"
                        field="primary_address"
                        placeholder="Search"
                        ariaLabel="Filter Primary Address" />
                </th>
                <th class="bg-orange">
                    <p-columnFilter
                        type="text"
                        field="city"
                        placeholder="Search"
                        ariaLabel="Filter City" />
                </th>
                <th class="bg-orange">
                    <p-columnFilter
                        type="text"
                        field="state"
                        placeholder="Search"
                        ariaLabel="Filter State" />
                </th>
                <th class="bg-orange">
                    <p-columnFilter
                        type="text"
                        field="country"
                        placeholder="Search"
                        ariaLabel="Filter Country" />
                </th>
                <th class="bg-orange">
                    <p-columnFilter
                        type="text"
                        field="gstin"
                        placeholder="Search"
                        ariaLabel="Filter GSTIN" />
                </th>
                <th class="bg-orange">
                    <p-columnFilter
                        type="text"
                        field="status"
                        placeholder="Search"
                        ariaLabel="Filter ststus" />
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-vendor>
            <tr>
                <!-- <td>
                    <p-tableCheckbox [value]="vendor" />
                </td> -->
                <td>
                    <button pButton type="button" icon="pi pi-eye" (click)="goToVendorDetails(vendor.get_user,vendor.status,vendor.business_name)" class="p-button-rounded" pTooltip="View Details"></button>
                </td>
                <td><strong>{{ vendor.business_name }}</strong></td>
                <td><strong>{{ vendor.vendor_code }}</strong></td>
                <td><strong>{{ vendor.primary_address.address_title }}</strong></td>
                <!-- <td>{{ vendor.vendor_group }}</td> -->
                <td><strong>{{vendor.primary_address.city}}</strong></td>
                <td><strong>{{getStateLabel(vendor.primary_address.state,vendor.primary_address.country)}}</strong></td>
                <td><strong>{{getcountries(vendor.primary_address.country)}}</strong></td>
                <td><strong>{{vendor.primary_address.tax_details.gstn}}</strong></td>
                <td><strong>{{vendor.status}}</strong></td>
            </tr>
        </ng-template>
    </p-table>
</div>
